import React, { useState } from 'react';
import { I18n } from 'react-redux-i18n';
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Tooltip,
} from '@material-ui/core';
import HelpIcon from '@material-ui/icons/Help';

/**
 * Bouton contact / aide d'un partenaire — base neuve, alimentée par /partners/all.
 *
 * @param {String} props.name  nom du partenaire
 * @param {Object} props.contact partner.partner_contact (couples label -> valeur)
 * @param {Object} props.documentation partner.documentation url de la doc
 * @param {String} props.iconClassName classe de l'icône déclencheur (style selon la carte)
 */
const PartnerContact = ({
	name,
	contact,
	documentation,
	iconClassName = 'card-active__icon',
}) => {
	const [open, setOpen] = useState(false);

	const hasContact = contact && Object.keys(contact).length > 0;

	// Rien à afficher : ni contact, ni documentation.
	if (!hasContact && !documentation) return null;

	return (
		<>
			<Tooltip title={I18n.t('partner.tooltip_partner_help')}>
				<div className={iconClassName} onClick={() => setOpen(true)}>
					<HelpIcon />
				</div>
			</Tooltip>

			<Dialog open={open} onClose={() => setOpen(false)}>
				<DialogTitle>
					{I18n.t('general.help')} {name}
				</DialogTitle>
				<DialogContent>
					{hasContact ? (
						<div>
							<h2>{I18n.t('general.contact')}</h2>
							<ul>
								{Object.keys(contact).map(key => (
									<li key={key}>
										{key} : {contact[key]}
									</li>
								))}
							</ul>
						</div>
					) : null}

					{documentation ? (
						<div>
							<h2>{I18n.t('general.documentation')}</h2>
							<p>
								<a
									target="_blank"
									rel="noopener noreferrer"
									href={documentation}>
									{name
										? I18n.t('partner.documentation', { partner: name })
										: I18n.t('general.documentation')}
								</a>
							</p>
						</div>
					) : null}
				</DialogContent>
				<DialogActions>
					<Button
						onClick={() => setOpen(false)}
						color="primary"
						variant="contained"
						className="button-valid">
						{I18n.t('general.close')}
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
};

export default PartnerContact;
